// @core/api/endpoints/project/get_project_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProjectStatsResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get project statistics
 * Returns aggregate statistics for the project including item counts by status, average cycle time, and team workload distribution.
 */
export async function GetProjectStats(
  project_id: string,
  options?: RequestOptions
): Promise<ProjectStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/stats`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ProjectStatsResponse>(requestPath, { ...requestOptions });
}
